import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import _ from 'lodash';

import './add_photo_button.scss';

class AddPhotoButton extends Component {
  constructor(props) {
    super(props);

    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    if (files && _.size(files) > 0) {
      const filesWithPreview = _.map(files, file => {
        file.preview = window.URL.createObjectURL(file);
        return file;
      });
      this.props.onDrop(filesWithPreview);
    }
  }

  render() {
    const { className, children, multiple } = this.props;

    return (
      <Dropzone accept="image/jpeg, image/png" onDrop={this.onDrop} multiple={multiple}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div {...getRootProps()} className={classNames(className, { hovering: isDragActive })}>
            <input className="add-photo-button__input" {...getInputProps()} />
            {children}
          </div>
        )}
      </Dropzone>
    );
  }
}

AddPhotoButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onDrop: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
};

AddPhotoButton.defaultProps = {
  className: 'btn btn-link',
  children: 'Add Photos +',
  multiple: true,
};

export default AddPhotoButton;
